import { Box, CircularProgress } from "@mui/material";

const FallbackLoad: React.FC = () => {
    return <Box sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }}>
        <CircularProgress sx={{
            color: "primary.main"
        }} />
    </Box>
}

export default FallbackLoad;